import { render, staticRenderFns } from "./MultiImageInputField.vue?vue&type=template&id=68b704d8&scoped=true"
import script from "./MultiImageInputField.vue?vue&type=script&lang=ts"
export * from "./MultiImageInputField.vue?vue&type=script&lang=ts"
import style0 from "./MultiImageInputField.vue?vue&type=style&index=0&id=68b704d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b704d8",
  null
  
)

export default component.exports